import { internalActions } from "@/action/internalActions";
import { userHeartbeatInterval } from "@/model/Settings";
import { useBoardStore } from "@/store/board";
import { useUsersOnBoardStore } from "@/store/usersOnBoard";

const heartbeatWorker = new Worker("/workers/heartbeat.js");

heartbeatWorker.addEventListener("message", () => {
  _onHeartbeatTick();
});

export function startUserHeartbeat() {
  heartbeatWorker.postMessage({ action: "start", interval: userHeartbeatInterval });
}

export function stopUserHeartbeat() {
  heartbeatWorker.postMessage({ action: "stop" });
}

function _onHeartbeatTick() {
  internalActions.addMeOnBoard(useBoardStore().boardId());
  useUsersOnBoardStore().expireUsersOnBoard();
}
